
const EditableLabel = (props) => {

    return (
        <>
            {props.editOn ?
                <div className={props.editClassName ?? "title"}>
                    <input type="text"
                        autoFocus
                        style={{ width: "90%" }}
                        placeholder={props.placeholder ?? "Enter Text"}
                        value={props.textValue}
                        onInput={e => props.setTextValue(e.target.value)}
                        onBlur={props.handleLoseFocus}
                    />
                    <i
                        style={{ marginLeft: '5px', cursor: "pointer" }}
                        className={props.textValue ? "fa fa-save" : "fa fa-circle-xmark"}
                        onClick={props.handleLoseFocus}
                        title={props.textValue ? "Save" : 'Cancel'}
                    />
                </div>
                :
                <div className={(props.className ?? "title")} >

                    <label className={props.labelClassName}>{props.textValue}
                    {props.showPencil ?
                            <i style={{ marginLeft: '5px', cursor: "pointer" }} className="fa fa-pencil text-end" onClick={props.handleEditTextValue}></i>
                            :
                            <></>
                        }
                        {props.showDelete && props.handleDelete ?
                            <i style={{ marginLeft: '5px', cursor: "pointer" }} className="fa fa-x text-end" onClick={e => { e.stopPropagation(); props.handleDelete(); }}></i>
                            :
                            <></>
                        }
                    </label> 
                </div>
            }
        </>
    );
}

export default EditableLabel